import { callApiToServer } from "../callApi";

export async function deleteCourseSession(authtoken, courseSessionId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      "session_id": courseSessionId
    })
    let endUrl = `v1/auth/admin/delete-course-session`;
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);
    console.log(responseData);
    return responseData;
  } catch (err) {
    throw err;
  }
}
